// extracted by mini-css-extract-plugin
module.exports = {"mobileNavigation":"navigation_mobileNavigation__3KwCB","mobileItem":"navigation_mobileItem__3hdEC"};